"use strict";
import { popupRegistry } from "components/Popups/registry";
import { didUserReject } from "utils/swapErrorToUserReadableMessage";
export const TRANSACTION_CANCELLED_TITLE = "Transaction Cancelled";
export const TRANSACTION_CANCELLED_DESCRIPTION = "You cancelled the transaction in your wallet.";
export const TRANSACTION_CANCELLED_TOAST_MS = 5e3;
const MAX_ERROR_CHAIN_DEPTH = 8;
function nextChainedError(current) {
  return current.error ?? current.data?.originalError ?? current.originalError ?? current.cause;
}
export function isUserRejectedTransactionError(error) {
  let current = error;
  for (let depth = 0; current && depth < MAX_ERROR_CHAIN_DEPTH; depth++) {
    if (didUserReject(current)) {
      return true;
    }
    if (typeof current === "string") {
      break;
    }
    current = nextChainedError(current);
  }
  return false;
}
const MAX_READABLE_REASON_LENGTH = 120;
function extractDeepestReason(error) {
  let reason;
  let current = error;
  for (let depth = 0; current && depth < MAX_ERROR_CHAIN_DEPTH; depth++) {
    if (typeof current === "string") {
      reason = current;
      break;
    }
    reason = current.reason ?? current.message ?? reason;
    current = nextChainedError(current);
  }
  return typeof reason === "string" ? reason : void 0;
}
export function getReadableTransactionFailureReason(error, fallback = "Please try again.") {
  if (isUserRejectedTransactionError(error)) {
    return TRANSACTION_CANCELLED_DESCRIPTION;
  }
  let reason = extractDeepestReason(error)?.trim() ?? "";
  if (reason.toLowerCase().startsWith("execution reverted: ")) {
    reason = reason.slice("execution reverted: ".length);
  }
  const lower = reason.toLowerCase();
  if (lower.includes("insufficient funds")) {
    return "Insufficient BNB to cover the transaction and network fees.";
  }
  if (lower.includes("expired") || lower.includes("deadline")) {
    return "The transaction deadline passed before it could confirm. Please try again.";
  }
  if (lower.includes("price slippage check") || lower.includes("insufficient_a_amount") || lower.includes("insufficient_b_amount") || lower.includes("insufficient_output_amount") || lower.includes("excessive_input_amount") || lower.includes("too little received") || lower.includes("too much requested")) {
    return "The price moved beyond your slippage tolerance. Please try again.";
  }
  if (lower.includes("cannot estimate gas") || lower.includes("gas required exceeds") || lower.includes("execution reverted")) {
    return "The transaction would fail on-chain. Please check your inputs and try again.";
  }
  const looksLikeRawDump = reason.length > MAX_READABLE_REASON_LENGTH || reason.includes("{") || reason.includes("code=") || reason.includes("[ See:") || reason.includes("0x") && reason.length > 60;
  if (reason && !looksLikeRawDump) {
    return reason;
  }
  return fallback;
}
export function showTransactionErrorPopup({
  error,
  buildContent,
  failureTitle,
  failureFallback,
  cancelledKey,
  failureKey,
  failureDurationMs
}) {
  if (isUserRejectedTransactionError(error)) {
    popupRegistry.addPopup(
      buildContent({ title: TRANSACTION_CANCELLED_TITLE, description: TRANSACTION_CANCELLED_DESCRIPTION }),
      cancelledKey,
      TRANSACTION_CANCELLED_TOAST_MS
    );
    return;
  }
  popupRegistry.addPopup(
    buildContent({ title: failureTitle, description: getReadableTransactionFailureReason(error, failureFallback) }),
    failureKey,
    failureDurationMs
  );
}
